import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const trustItems = ['+200 entrenadores ya lo tienen', 'Garantía 7 días sin preguntas', 'Acceso inmediato', 'Pago único — Mercado Pago'];
export function Hero() {
  return <>
      <div className="bg-gold px-4 py-2 text-center font-mono text-[10px] font-bold uppercase tracking-[0.08em] text-ink sm:text-[11px]" data-id="element-79">
        🔒 Oferta por tiempo limitado — acceso inmediato + bonos gratis
      </div>

      <header className="border-b border-[#d4af37]/18 bg-ink" data-id="element-80">
        <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8" aria-label="Navegación principal" data-id="element-81">
          <a href="#inicio" className="font-display text-2xl font-bold tracking-[-0.04em] text-ivory focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-82">
            Megapack
          </a>
          <a href="#pricing" className="font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-83">
            Ver versiones
          </a>
        </nav>
      </header>

      <main id="inicio" data-id="element-84">
        <section className="border-b border-[#d4af37]/18 px-5 py-20 text-center sm:px-8 sm:py-28 lg:py-32" data-id="element-85">
          <Reveal className="mx-auto max-w-4xl" data-id="element-86">
            <p className="mx-auto inline-flex items-center gap-2 border border-[#d4af37]/55 px-3 py-2 font-mono text-[9px] font-semibold uppercase tracking-[0.14em] text-gold sm:text-[10px]" data-id="element-87">
              Sistema para entrenadores — Argentina 2026
            </p>
            <h1 className="mt-7 font-display text-5xl font-black leading-[0.92] tracking-[-0.055em] text-ivory sm:text-6xl lg:text-7xl" data-id="element-88">
              Dejá de ser
              <br data-id="element-89" />
              <em className="font-normal text-ivory" data-id="element-90">
                el entrenador que{' '}
                <strong className="font-black text-gold" data-id="element-91">ruega</strong>
              </em>
              <br data-id="element-92" />
              <em className="font-normal text-ivory" data-id="element-93">que le digan que sí.</em>
            </h1>
            <img src="https://cdn.magicpatterns.com/uploads/dLLnC3Bgmp5o1ZasxY5xvi/1-removebg-preview.webp" alt="Megapack Entrenadores, edición PRO 2026" className="mx-auto mt-8 w-full max-w-[280px] object-contain sm:max-w-[340px]" data-id="element-94" />
            <p className="mx-auto mt-7 max-w-[500px] text-base leading-7 text-sage sm:text-lg" data-id="element-95">
              El método para conseguir, cerrar y retener alumnos usando
              Instagram y WhatsApp — sin ads, sin ser influencer, sin depender
              del boca a boca.
            </p>
            <a href="#pricing" className="gold-button mx-auto mt-9 flex min-h-14 max-w-[420px] items-center justify-center bg-gold px-6 font-mono text-[11px] font-bold uppercase tracking-wider text-ink transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-96">
              Quiero el Megapack Entrenadores →
            </a>
            <p className="mt-3 text-xs text-sage" data-id="element-97">
              Pago único · Acceso inmediato · 7 días de garantía
            </p>
          </Reveal>

          <Reveal delay={0.08} className="mx-auto mt-12 max-w-5xl" data-id="element-98">
            <div className="grid border-y border-[#d4af37]/18 sm:grid-cols-4" data-id="element-99">
              {trustItems.map((item, index) => <div key={item} className={`flex items-center justify-center gap-2 px-4 py-4 text-xs text-ivory ${index > 0 ? 'sm:border-l sm:border-[#d4af37]/18' : ''}`} data-id="element-100">
                  <CheckIcon size={14} className="shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-101" />
                  <span data-id="element-102">{item}</span>
                </div>)}
            </div>
          </Reveal>
        </section>
      </main>
    </>;
}